import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import B2becCustomSelect from '@/components/B2becCustomSelect'

import { ORDER_STATUS_FILTER_OPTIONS } from './order-status.constant'
import styles from './Status.module.scss'

interface StatusProps {
  selectedStatus: string
  onSelectStatus: (value: string) => void
}

export const Status = ({ selectedStatus, onSelectStatus }: StatusProps) => {
  const { t } = useTranslation()

  const options = useMemo(() => {
    return ORDER_STATUS_FILTER_OPTIONS.map((status) => ({
      ...status,
      label: t(status.label),
    }))
  }, [t])

  const handleChange = (value: string): void => {
    onSelectStatus(value)
  }

  return (
    <div className={styles.wrapper}>
      <span className={styles.title}>{t('filter.status')}</span>
      <B2becCustomSelect
        className={styles.select}
        options={options}
        value={selectedStatus}
        onChange={handleChange}
      />
    </div>
  )
}
